// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discard-dialog {
  gap: 12px;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  margin-right: -8px;
}

.dialog-content p {
  margin: 0;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
}

.confirm-btn {
  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;
  color: white !important;
  border-radius: 100px !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRpc2NhcmQtcGF5bWVudC1kaWFsb2cuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFNBQVM7QUFDWDs7QUFFQTtFQUNFLGFBQWE7RUFDYiw4QkFBOEI7RUFDOUIsbUJBQW1CO0FBQ3JCOztBQUVBO0VBQ0Usa0JBQWtCO0FBQ3BCOztBQUVBO0VBQ0UsU0FBUztBQUNYOztBQUVBO0VBQ0UsYUFBYTtFQUNiLHlCQUF5QjtBQUMzQjs7QUFFQTtFQUNFLHVFQUF1RTtFQUN2RSx1QkFBdUI7RUFDdkIsK0JBQStCO0VBQy9CLDJCQUEyQjtFQUMzQiwwQkFBMEI7QUFDNUI7O0FBRUE7RUFDRSw0Q0FBNEM7QUFDOUMiLCJmaWxlIjoiZGlzY2FyZC1wYXltZW50LWRpYWxvZy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmRpc2NhcmQtZGlhbG9nIHtcbiAgZ2FwOiAxMnB4O1xufVxuXG4uZGlhbG9nLWhlYWRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLmNsb3NlLWJ0biB7XG4gIG1hcmdpbi1yaWdodDogLThweDtcbn1cblxuLmRpYWxvZy1jb250ZW50IHAge1xuICBtYXJnaW46IDA7XG59XG5cbi5kaWFsb2ctYWN0aW9ucyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG59XG5cbi5jb25maXJtLWJ0biB7XG4gIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCg5MGRlZywgIzAwYjJmZiAwJSwgIzEyODhmZiAxMDAlKSAhaW1wb3J0YW50O1xuICBjb2xvcjogd2hpdGUgIWltcG9ydGFudDtcbiAgYm9yZGVyLXJhZGl1czogMTAwcHggIWltcG9ydGFudDtcbiAgZm9udC13ZWlnaHQ6IDcwMCAhaW1wb3J0YW50O1xuICBmb250LXNpemU6IDE0cHggIWltcG9ydGFudDtcbn1cblxuOmhvc3QgOjpuZy1kZWVwICoge1xuICBmb250LWZhbWlseTogXCJSb2JvdG9cIiwgc2Fucy1zZXJpZiAhaW1wb3J0YW50O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/discard-payment-dialog/discard-payment-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,g2CAAg2C","sourcesContent":[".discard-dialog {\n  gap: 12px;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.close-btn {\n  margin-right: -8px;\n}\n\n.dialog-content p {\n  margin: 0;\n}\n\n.dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.confirm-btn {\n  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;\n  color: white !important;\n  border-radius: 100px !important;\n  font-weight: 700 !important;\n  font-size: 14px !important;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
